export function swiper() {

  // トップページのKVにフェードを適用するSwiper初期化
  var swiperKV = new Swiper('.swiper-container-kv', {
    effect: 'fade',
    loop: true,
    speed: 2000,
    autoplay: {
      delay: 4000,
      disableOnInteraction: false
    },
    fadeEffect: {
      crossFade: true
    }
  });

  // Container0用のSwiper初期化（無限スクロールと自動スクロールを適用）
  const swiper0 = new Swiper('.swiper-container0', {
    loop: true,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },
    breakpoints: {
      0: {
        slidesPerView: 4,
        spaceBetween: 10,
      },
      420: {
        slidesPerView: 6,
        spaceBetween: 10,
      },
      769: {
        slidesPerView: 6,
        spaceBetween: 20,
      },
      1280: {
        slidesPerView: 10,
        spaceBetween: 20,
      },
      1920: {
        slidesPerView: 15,
        spaceBetween: 30,
      },
    },
    autoHeight: true,
    speed: 8000,
  });

  // Container1用のSwiper初期化
  const swiper1 = new Swiper('.swiper-container1', {
    navigation: {
      nextEl: '.swiper-button-next1',
      prevEl: '.swiper-button-prev1',
    },
    breakpoints: {
      0: {
        slidesPerView: 2,
        spaceBetween: 10,
      },
      420: {
        slidesPerView: 2,
        spaceBetween: 21,
      }
    },
  });

  // Container2用のSwiper初期化
  const swiper2 = new Swiper('.swiper-container2', {
    navigation: {
      nextEl: '.swiper-button-next2',
      prevEl: '.swiper-button-prev2',
    },
    breakpoints: {
      0: {
        slidesPerView: 2,
        spaceBetween: 10,
      },
      420: {
        slidesPerView: 2,
        spaceBetween: 21,
      }
    },
  });

}
